export default function initVideoControls() {
  document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelectorAll(".video__play-btn").length === 0) {
      return;
    }

    document
      .querySelector(".video__play-btn")
      .addEventListener("click", toggleMute);

    function toggleMute() {
      const video = document.querySelector(".video__player");
      const viedoWrapper = document.querySelector(".video__wrapper");
      video.muted = !video.muted;
      viedoWrapper.classList.toggle("active");
    }
  });
}
